// Copyright (c) 2017 Deere & Company

import './modal-body.scss';
import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';
import LabeledString from '../../../../shared/components/labeled-string';
import LaborRate from '@deere/cps-it.warranty-model-factory/lib/labor-rate';
import {buildDate} from '../../../../shared/services/build-date';

const LaborRateModalBody = props =>
    <section className='modal-body'>
        <section className='claim-info'>
            <span>
                {props.laborRate.requestId}
            </span>
            <LabeledString
                data={buildDate(props.laborRate.effectiveDate)}
                label='EFFECTIVE_DATE'
            />
        </section>
        <section className='comments'>
            <label>
                <FormattedMessage id='INTERNAL_DEERE_COMMENTS'/>
                <textarea
                    maxLength={255}
                    onChange={props.onInternalDeereCommentsChange}
                    rows={5}
                    value={props.laborRate.internalDeereComments}
                />
            </label>
            <label>
                <FormattedMessage id='COMMENTS_TO_DEALER'/>
                <textarea
                    maxLength={255}
                    onChange={props.onCommentsToDealerChange}
                    rows={5}
                    value={props.laborRate.notesToDealer}
                />
            </label>
        </section>
    </section>;

LaborRateModalBody.displayName = 'LaborRateModalBody';
LaborRateModalBody.propTypes = {
    laborRate: PropTypes.instanceOf(LaborRate).isRequired,
    onCommentsToDealerChange: PropTypes.func.isRequired,
    onInternalDeereCommentsChange: PropTypes.func.isRequired
};

export default LaborRateModalBody;



// WEBPACK FOOTER //
// ./src/tcsm/labor-rate-approval/components/modal/modal-body.js